import * as THREE from "three";

export async function _loadFile(context, name) {
  let form = document.createElement("form");
  form.style.display = "none";
  document.body.appendChild(form);

  let fileInput = document.createElement("input");
  fileInput.multiple = false;
  fileInput.type = "file";
  fileInput.addEventListener("change", () => {
    let extension = fileInput.files[0].name.split(".").pop().toLowerCase();
    if (extension !== "json") return;
    let reader = new FileReader();
    // reader.addEventListener( 'progress', function ( event ) {
    //   let size = '(' + Math.floor( event.total / 1000 ).format() + ' KB)';
    //   let progress = Math.floor( ( event.loaded / event.total ) * 100 ) + '%';
    //   console.log( 'Loading', fileInput.files[0].name, size, progress );
    // } );
    reader.addEventListener("load", event => {
      let contents = event.target.result;
      let dataJson;

      try {
        // Compressed JSON case

        dataJson = context.parseJSON(contents);
        context.versionManager.setVersion(dataJson.version);

        if (dataJson.GUI !== undefined) {
          new THREE.ObjectLoader().parse(dataJson.GUI, scene => {
            context.resetGUIScene(scene);
          });
        }
        const sceneSave = dataJson.default !== undefined ? dataJson.default : dataJson;
        new THREE.ObjectLoader().parse(sceneSave, scene => {
          if (!scene.userData.postProcessing) {
            scene.userData.postProcessing = {
              ssao: {},
              bloom: {},
              godrays: {},
              hueSaturation: {},
              brightnessContrast: {},
            };
          }
          if (!scene.userData.toneMapping) {
            scene.userData.toneMapping = {
              mode: THREE.NoToneMapping,
              exposure: 1,
            };
          }
          context.resetEditScene(context.postLoadSceneFile(scene));
        });
      } catch (e) {
        console.error(e);
      }
    });
    reader.readAsText(fileInput.files[0]);
    form.reset();
  });
  form.appendChild(fileInput);
  fileInput.click();
  context.render();
}

export function _saveFile(context, name) {
  let a = document.createElement("a");
  let scenePublish = {};

  scenePublish["default"] = context.sceneEdit;
  scenePublish["GUI"] = context.sceneGUI;
  scenePublish["version"] = context.versionManager.getVersion();

  const compressedScene = context.compressScene(scenePublish);
  let file = new Blob([JSON.stringify(compressedScene)], {
    type: "text/json",
  });
  a.href = window.URL.createObjectURL(file);
  a.download = name + ".json";
  a.click();
}
